var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-container"},_vm._l((_vm.feedbackBoxes),function(box){return _c('div',{key:box.id},[_c('FeedbackBox',{attrs:{"id":box.id,"alert-data":box.data},on:{"closeFeedback":function($event){return _vm.removeBox(box.id)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }